import React from "react";
// eslint-disable-next-line import/named
import ContentLoader, { IContentLoaderProps } from "react-content-loader";

export type ContentPlaceHolderProps = IContentLoaderProps & {
  children?: React.ReactNode;
};

export const ContentPlaceHolder: React.FC<ContentPlaceHolderProps> = ({
  children,
  ...props
}) => (
  <ContentLoader uniqueKey="content-loader-key" {...props}>
    {children}
  </ContentLoader>
);

ContentPlaceHolder.displayName = "ContentPlaceHolder";

export default ContentPlaceHolder;
